var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('div',[_c('center',[_c('img',{staticStyle:{"display":"block"},attrs:{"width":"50%","src":require("@/assets/logo-white-new.png")}}),_vm._v(" Copyright © 2021 UFA565. All Right Reserve ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }